import script from "./threeUpImageBand.vue?vue&type=script&lang=js"
export * from "./threeUpImageBand.vue?vue&type=script&lang=js"

import "./threeUpImageBand.vue?vue&type=style&index=0&id=1c202feb&lang=scss"

const __exports__ = script;

export default __exports__